import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft } from "@fortawesome/free-solid-svg-icons";

const BackToButton = (props) => {
    const buttonText = props.text ? props.text : "Back";

    return (
        <button className="button" onClick={props.onClick} title={buttonText}>
            <FontAwesomeIcon icon={faArrowLeft} />
        </button>
    );
};

export default BackToButton;
